import { render } from "./KakaoAds.vue?vue&type=template&id=0b77db12"
import script from "./KakaoAds.vue?vue&type=script&lang=js"
export * from "./KakaoAds.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__